<template>
    <div class="header">
        <div class="header-top">
            <div class="container">
                <div class="head-top">
                    <div class="logo">
                        <h1>
                            <router-link to="/">Git <span>游戏</span></router-link>
                        </h1>
                    </div>
                    <div class="top-nav">
                        <span class="menu" @click="showMenu"><img src="static/images/menu.png" alt=""> </span>
                        <ul>
                            <li :class="[$route.meta.index==0?'active':'']" @click="hideMenu">
                                <router-link to="/">首页</router-link>
                            </li>
                            <li :class="[$route.meta.index==1?'active':'']" @click="hideMenu">
                                <router-link to="/game">游戏</router-link>
                            </li>
                            <li :class="[$route.meta.index==2?'active':'']" @click="hideMenu">
                                <router-link to="/blog">博客</router-link>
                            </li>
                            <li :class="[$route.meta.index==3?'active':'']" @click="hideMenu">
                                <router-link to="/event">事件</router-link>
                            </li>
                            <li :class="[$route.meta.index==4?'active':'']" @click="hideMenu">
                                <router-link to="/about">关于</router-link>
                            </li>

                            <!--<li>-->
                                <!--<a href="http://www.gityx.com/" target="_blank">新首页</a>-->
                            <!--</li>-->
                            <li>
                                <a href="http://bbs.gityx.com" target="_blank">论坛</a>
                            </li>
                            <li>
                                <el-form :inline="true" :model="formInline" class="form-search" @submit.native.prevent>
                                    <el-form-item>
                                        <el-input  v-model="formInline.name" ref="search"  :placeholder="tips" tabindex="1" @keyup.enter.native="onSubmit"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" class="btn-search" @click="onSubmit">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                            </li>
                            <div class="clearfix"></div>
                        </ul>
                        <!--script-->
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
  components: {},
  data() {
    return {
      keyword: '',
      tips: '请输入游戏关键字',
      formInline: {
        name: ''

      }
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log('测试回车')
      this.keyword = this.$refs.search.value.trim()
      if (this.keyword == '') {
        this.$notify({
          title: '提示',
          message: '搜索的关键字不能为空',
          type: 'warning',
          position: 'bottom-right',
          duration: 1000
        })
      } else {
        this.$router.push({ path: '/s=' + this.keyword })
        this.keyword = ''
      }
    },
    showMenu() {
      $('.top-nav ul').slideToggle(500, function() {})
    },
    hideMenu() {
      // $('.top-nav ul').slideToggle(500, function() {})
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue